"use client"

import { useEffect, useState } from "react"
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts"
import axios from "axios"
import { Calendar } from "lucide-react" // Import Calendar icon

export default function ProjectStatusChart() {
  const [projectData, setProjectData] = useState([])
  const [filters, setFilters] = useState({ fromDate: "", toDate: "" })
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => {
    fetchData()
  }, [filters])

  const fetchData = async () => {
    try {
      const query = new URLSearchParams(filters).toString()
      const url = query ? `http://localhost:5000/project-status-stats?${query}` : `http://localhost:5000/project-status-stats`
      console.log("Fetching data from:", url) // Debugging: Log the API URL
      const response = await axios.get(url)
      console.log("API Response:", response.data) // Debugging: Log the API response
      const data = response.data.map((item) => ({
        name: item.status,
        value: item.count || 0, // Ensure zero count is handled
        color: getColor(item.status),
      }))
      setProjectData(data)
    } catch (error) {
      console.error("Error fetching project status data:", error)
    }
  }

  const getColor = (status) => {
    switch (status) {
      case "unassigned":
        return "#FF8042"
      case "assigned":
        return "#FFBB28"
      case "completed":
        return "#00C49F"
      case "cancelled":
        return "#FF0000"
      default:
        return "#8884d8"
    }
  }

  return (
    <div className="relative">
      <ResponsiveContainer width="100%" height={300}>
        {projectData.length > 0 ? (
          <PieChart>
            <Pie
              data={projectData}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
              label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
            >
              {projectData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        ) : (
          <p className="text-center text-gray-500">No data available</p>
        )}
      </ResponsiveContainer>
      <div className="text-xs text-gray-500 text-center mt-2">
        Project status distribution (number of projects per status)
      </div>
      <Calendar
        className="absolute top-2 right-2 w-5 h-5 text-gray-500 cursor-pointer"
        onClick={() => setShowFilter(!showFilter)}
      />
      {showFilter && (
        <div className="absolute top-10 right-0 z-10 p-4 bg-white border rounded shadow">
          <h3 className="mb-2 text-sm font-semibold">Project Status Filter</h3>
          <label className="block mb-2 text-xs">
            From Date:
            <input
              type="date"
              className="block w-full p-1 border rounded"
              value={filters.fromDate}
              onChange={(e) => setFilters((prev) => ({ ...prev, fromDate: e.target.value }))}
            />
          </label>
          <label className="block mb-2 text-xs">
            To Date:
            <input
              type="date"
              className="block w-full p-1 border rounded"
              value={filters.toDate}
              onChange={(e) => setFilters((prev) => ({ ...prev, toDate: e.target.value }))}
            />
          </label>
          <button
            className="px-2 py-1 text-xs text-white bg-blue-500 rounded"
            onClick={() => setShowFilter(false)}
          >
            Apply
          </button>
        </div>
      )}
    </div>
  )
}
